module.exports = __webpack_public_path__ + "img/str.ec0ca423.png";